var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_jp_flag)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 24,
    height: 24,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 12,
    r: 5,
    fill: "#BC002D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 24,
    height: 24,
    rx: 12,
    fill: "none",
    stroke: "#D1D5DB",
    strokeWidth: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_jp_flag"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJa);
export default __webpack_public_path__ + "static/media/ja.67163fec21307eab28f9ced3ada29c32.svg";
export { ForwardRef as ReactComponent };